// GAME
export const GAME_TICK = 'gameTick';

// CAMERA + MOUSE
export const CAMERA_LEFT = 'CAMERA_LEFT';
export const CAMERA_UP = 'CAMERA_UP';
export const CAMERA_RIGHT = 'CAMERA_RIGHT';
export const CAMERA_DOWN = 'CAMERA_DOWN';
export const CAMERA_ROTATE_CLOCKWISE = 'CAMERA_ROTATE_CLOCKWISE';
export const CAMERA_ROTATE_COUNTER_CLOCKWISE =
  'CAMERA_ROTATE_COUNTER_CLOCKWISE';
export const CAMERA_CYCLE_ZOOM = 'CAMERA_CYCLE_ZOOM';
export const MOUSE_MOVE = 'MOUSE_MOVE';
export const MOUSE_CLICK = 'MOUSE_CLICK';

// OTHER
export const TOGGLE_DEBUG_OVERLAY = 'TOGGLE_DEBUG_OVERLAY';

export const HOLDABLE_ACTION_TYPES = {
  CAMERA_LEFT,
  CAMERA_UP,
  CAMERA_RIGHT,
  CAMERA_DOWN,
};



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js